// Global helper: any "Book a consultation" CTA dispatches this event;
// <BookConsultationProvider /> mounted in App.js opens the modal.

import { track } from "./analytics";

export const BOOK_EVENT = "dc:open-book-consultation";

export function openBookConsultation(cta_location) {
  if (typeof window === "undefined") return;
  // Fire GA4 / GTM event for the click — every CTA on the site funnels
  // through here, so this is the single, reliable place to track intent.
  try {
    track("book_consultation_click", {
      cta_location: cta_location || "unknown",
    });
  } catch {
    /* analytics is best-effort */
  }
  window.dispatchEvent(new CustomEvent(BOOK_EVENT));
}
